module.exports = __webpack_public_path__ + "static/media/vasu_sharma.18a60553.jpeg";